var map = {
	"./google-laurel-da-DK.svg": 97929,
	"./google-laurel-de-DE.svg": 53107,
	"./google-laurel-en-GB.svg": 25337,
	"./google-laurel-en-US.svg": 80286,
	"./google-laurel-es-ES.svg": 94309,
	"./google-laurel-es-MX.svg": 18182,
	"./google-laurel-fr-FR.svg": 1513,
	"./google-laurel-it-IT.svg": 57907,
	"./google-laurel-nb-NO.svg": 7796,
	"./google-laurel-nl-NL.svg": 59505,
	"./google-laurel-pl-PL.svg": 54965,
	"./google-laurel-pt-BR.svg": 21981,
	"./google-laurel-pt-PT.svg": 15317,
	"./google-laurel-sv-SE.svg": 75544
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39909;